import { proxy, useSnapshot } from 'valtio';
import throttle from 'lodash.throttle';
import { onlineManager } from '@tanstack/react-query';
import { isNullable } from 'effect/Predicate';
import { Option } from 'effect';
export const ErrorCodes = {
    UNKNOWN: 'unknown',
    UPLOAD_FILE_ERROR: 'upload-file-error',
    SESSION_ID_ERROR: 'session-id-error',
    SUPPORT_CASE_MISMATCH_ERROR: 'support-case-mismatch-error',
    DOWNLOAD_TRANSCRIPT_ERROR: 'download-transcript-error',
    SECURE_FORM_ALREADY_SUBMITTED: 'secure-form-already-submitted',
    OFFLINE: 'offline',
};
const errorStore = proxy({
    state: Option.none(),
});
const setErrorState = (error) => {
    errorStore.state = Option.fromNullable(error);
};
const setErrorStateThrottleObject = throttle(setErrorState, 10000, {
    leading: false,
});
export const setErrorStateThrottled = (error) => {
    if (isNullable(error)) {
        setErrorState(undefined);
        setErrorStateThrottleObject.cancel();
        return;
    }
    setErrorStateThrottleObject(error);
};
const setUnknownErrorThrottled = (error) => setErrorStateThrottled({
    code: ErrorCodes.UNKNOWN,
    originalError: error,
});
export const useErrorState = () => {
    const errorState = useSnapshot(errorStore);
    return {
        errorState: errorState.state,
        setErrorState,
        setUnknownErrorThrottled,
    };
};
onlineManager.subscribe(online => setErrorStateThrottled(online ? undefined : { code: ErrorCodes.OFFLINE }));
